import React from 'react'
import CIcon from '@coreui/icons-react'

const _nav =  [
  {
    _tag: 'CSidebarNavItem',
    name: 'Scanner',
    to: '/scanner',
    icon: 'cil-chart-pie',
    badge: {
      color: 'info',
      //text: 'NEW',
    }
  },
  // {
  //   _tag: 'CSidebarNavTitle',
  //   _children: ['Gerenciamento de Ativos']
  // },
  // {
  //   _tag: 'CSidebarNavDropdown',
  //   name: 'Inversores',
  //   route: '/pages',
  //   icon: 'cil-cursor',
  //   _children: [
  //     {
  //       _tag: 'CSidebarNavItem',
  //       name: 'Lista Geral',
  //       to: '/inversores',
  //     },
  //     {
  //       _tag: 'CSidebarNavItem',
  //       name: 'Indicadores',
  //       to: '/base/cards',
  //     },
  //   ],
  // },
  //{
  //  _tag: 'CSidebarNavDropdown',
  //  name: 'Buttons',
  //  route: '/buttons',
  //  icon: 'cil-cursor',
  //  _children: [
  //    {
  //      _tag: 'CSidebarNavItem',
  //      name: 'Buttons',
   //     to: '/buttons/buttons',
   //   },
   //   {
   //     _tag: 'CSidebarNavItem',
    //    name: 'Brand buttons',
   //     to: '/buttons/brand-buttons',
   //   },
   //   {
   //     _tag: 'CSidebarNavItem',
   //     name: 'Buttons groups',
   //     to: '/buttons/button-groups',
    //  },
   //   {
    //    _tag: 'CSidebarNavItem',
    //    name: 'Dropdowns',
     //   to: '/buttons/button-dropdowns',
     // }
   // ],
 // },
 // {
//    _tag: 'CSidebarNavItem',
 //   name: 'Charts',
 //   to: '/charts',
 //   icon: 'cil-chart-pie'
 // },
 // {
 //   _tag: 'CSidebarNavDropdown',
 //   name: 'Icons',
 //   route: '/icons',
  //  icon: 'cil-star',
 //   _children: [
 //     {
 //       _tag: 'CSidebarNavItem',
 //       name: 'CoreUI Free',
  //      to: '/icons/coreui-icons',
  //      badge: {
  //        color: 'success',
  //        text: 'NEW',
   //     },
   //   },
   //   {
    //    _tag: 'CSidebarNavItem',
    //    name: 'CoreUI Flags',
    //    to: '/icons/flags',
    //  },
    //  {
     //   _tag: 'CSidebarNavItem',
     //   name: 'CoreUI Brands',
     //   to: '/icons/brands',
     // },
  //  ],
 // },
 // {
 //   _tag: 'CSidebarNavDropdown',
 //   name: 'Notifications',
  //  route: '/notifications',
 //   icon: 'cil-bell',
  //  _children: [
  //    {
  //      _tag: 'CSidebarNavItem',
  //      name: 'Alerts',
  //      to: '/notifications/alerts',
  //    },
  //    {
  //      _tag: 'CSidebarNavItem',
  //      name: 'Badges',
  //      to: '/notifications/badges',
  //    },
  //    {
   //     _tag: 'CSidebarNavItem',
  //      name: 'Modal',
  //      to: '/notifications/modals',
  //    },
  //    {
  //      _tag: 'CSidebarNavItem',
  //      name: 'Toaster',
  //      to: '/notifications/toaster'
  //    }
  //  ]
 // },
 // {
 //   _tag: 'CSidebarNavItem',
  //  name: 'Widgets',
  //  to: '/widgets',
  //  icon: 'cil-calculator',
 //   badge: {
  //    color: 'info',
  //    text: 'NEW',
  //  },
  //},
 // {
  //  _tag: 'CSidebarNavDivider'
  //},
  // {
  //   _tag: 'CSidebarNavTitle',
  //   _children: ['Configurações'],
  // },
  //{
 //   _tag: 'CSidebarNavDropdown',
 //   name: 'Pages',
  //  route: '/pages',
 //   icon: 'cil-star',
  //  _children: [
  //    {
  //      _tag: 'CSidebarNavItem',
  //      name: 'Login',
   //     to: '/login',
  //    },
  //    {
  //      _tag: 'CSidebarNavItem',
   //     name: 'Register',
   //     to: '/register',
   //   },
  //    {
  //      _tag: 'CSidebarNavItem',
  //      name: 'Error 404',
  //      to: '/404',
  //    },
  //    {
   //     _tag: 'CSidebarNavItem',
  //      name: 'Error 500',
  //      to: '/500',
  //    },
  //  ],
  //},
  // {
  //   _tag: 'CSidebarNavItem',
  //   name: 'Usuários',
  //   icon: 'cil-ban',
  //   badge: {
  //     color: 'secondary',
  //    // text: 'NEW',
  //   },
  //   addLinkClass: 'c-disabled',
  //   'disabled': true
  // },
  // {
  //   _tag: 'CSidebarNavDivider',
  //   className: 'm-2'
  // },
  //{
 //   _tag: 'CSidebarNavTitle',
//    _children: ['Labels']
 // },
 // {
 //   _tag: 'CSidebarNavItem',
 //   name: 'Label danger',
 //   to: '',
//    icon: {
//      name: 'cil-star',
//      className: 'text-danger'
//    },
 //   label: true
 // },
 // {
//    _tag: 'CSidebarNavItem',
//    name: 'Label info',
 //   to: '',
 //   icon: {
 //     name: 'cil-star',
 //     className: 'text-info'
 //   },
 //   label: true
 // },
  //{
  //  _tag: 'CSidebarNavItem',
  //  name: 'Label warning',
  //  to: '',
  //  icon: {
  //    name: 'cil-star',
  //    className: 'text-warning'
  //  },
  //  label: true
  //},
  //{
  //  _tag: 'CSidebarNavDivider',
  //  className: 'm-2'
  //}
]

export default _nav
